import { api } from 'api'
import { createAsyncThunk } from 'modules/store'

export const getAllPythonTypes = createAsyncThunk('users/getAllPythonTypes', async (_, { rejectWithValue }) =>
  api.pythonTypes.getAll().catch((error) => rejectWithValue(error.message)),
)
